(function() {
    try {     
      // handleの取得を試みる
      var productHandle = null;
      
      // 1. window.productHandleが設定されている場合
      if (window.productHandle) {
        productHandle = window.productHandle;
      }
      // 2. URLパスから取得（/products/{handle}の形式）
      else if (window.location.pathname) {
        var pathMatch = window.location.pathname.match(/\/products\/([^\/\?]+)/);
        if (pathMatch && pathMatch[1]) {
          productHandle = pathMatch[1];
        }
      }
      // 3. mxProductInfoCollectionから取得
      else if (window.mxProductInfoCollection && typeof window.mxProductInfoCollection === 'object') {
        var handles = Object.keys(window.mxProductInfoCollection);
        if (handles.length > 0) {
          productHandle = handles[0]; // 最初のhandleを使用
        }
      }
      
      // handleが取得できない場合は処理を中断
      if (!productHandle) {
        console.warn('Product handle could not be determined');
        return;
      }
  
      var history = [];
      var existing = localStorage.getItem('productHistory');
  
      if (existing) {
        try {
          var parsedHistory = JSON.parse(existing);
          if (Array.isArray(parsedHistory)) {
            history = parsedHistory;
          }
        } catch (e) {
          console.error('Could not parse product history from localStorage:', e);
        }
      }
  
      // handleでフィルタリング（既存のIDもフィルタリング対象から除外）
      history = history.filter(function(item) {
        return item !== productHandle;
      });
  
      // 現在のhandleを先頭に追加
      history.unshift(productHandle);
  
      // 最大11件まで保持
      history = history.slice(0, 11);
  
      localStorage.setItem('productHistory', JSON.stringify(history));
  
    } catch(e) {
      console.error('An error occurred in the recently viewed products script:', e);
    }
  })();